
    <router-outlet *ngIf="loadPage()"></router-outlet>
    <toast></toast>
    <app-loader-chargebee></app-loader-chargebee>
